module.exports = __webpack_public_path__ + "img/test.a0505a95.png";